import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import axiosInterceptors from "./Util/axiosInterceptor";
import "@szhsin/react-menu/dist/transitions/zoom.css";
import reportWebVitals from "./reportWebVitals";
import "@szhsin/react-menu/dist/index.css";
import { Toaster } from "react-hot-toast";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./Redux/store";
import React from "react";
import App from "./App";
import "./index.css";

axiosInterceptors();
ModuleRegistry.registerModules([AllCommunityModule]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Toaster
        containerStyle={{
          zIndex: 99999999999,
        }}
        toastOptions={{
          style: {
            zIndex: 99999999999,
          },
        }}
      />
      <App />
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
